<template>
    <div class="leftSource countB">
            <div class="btn_url">
                <div v-if="$store.state.modelType===0">
                    <FUrlBtn title="数据接入" :IconSize="20" path="/dataSource"></FUrlBtn>
                    <FUrlBtn title="数据准备" path="/dataSet"></FUrlBtn>
                    <FUrlBtn title="多维分析" :IconSize="20" path="/viewSet"></FUrlBtn>
                    <FUrlBtn title="原生分析" :IconSize="24" path="/OData"></FUrlBtn>
                </div>
                <div v-if="$store.state.modelType===3">
                    <FUrlBtn title="查找用户" :IconSize="16" path="/findUser"></FUrlBtn>
                    <FUrlBtn title="用户列表管理" :IconSize="14" path="/userList"></FUrlBtn>
                </div>
            </div>
        </div>
</template>

<script>
    import config from '@/assets/js/config'

    export default {
        name: 'FIconBtn',
        components: {},
        props: {},
        data() {
            return {}
        },
        methods: {},
        mounted() {},
        destroyed() {}
    }
</script>

<style lang="less">
.countB {
    width: calc((100% - 1%) / 2);
    height: 100%;
    display: inline-block;
    float: left;
    border-radius: 10px;
    padding: 20px;
}
.leftSource {
    margin-right: 1%;
    overflow: auto;
    width: 210px;
}
</style>